import type { LifeMoment, LifeMomentDto } from '@models/life-moment';
import type { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class LifeMomentsWebservice {
  readonly #http = inject(HttpClient);

  getLifeMomentById(partnerId: string, lifeMomentId: string): Observable<LifeMoment> {
    return this.#http.get<LifeMoment>(
      `${environment.api.obendy}/v2/partner-revision/${partnerId}/life-moments/${lifeMomentId}`
    );
  }

  getLifeMomentsList(): Observable<LifeMoment[]> {
    return this.#http.get<LifeMoment[]>(`${environment.api.obendy}/v2/life-moments`);
  }

  getPartnerLifeMoments(partnerId: string): Observable<LifeMoment[]> {
    return this.#http.get<LifeMoment[]>(`${environment.api.obendy}/v2/partner-revision/${partnerId}/life-moments`);
  }

  updatePartnerLifeMoment(
    partnerId: string,
    lifeMomentId: string,
    updatedLifeMoment: LifeMomentDto
  ): Observable<LifeMoment> {
    return this.#http.put<LifeMoment>(
      `${environment.api.obendy}/v2/partner-revision/${partnerId}/life-moments/${lifeMomentId}`,
      updatedLifeMoment
    );
  }
}
